/**
 * Converter Units
 *
 * An enumeration for Converter Units
 *
 * @author <a href="mailto:tor@zuehlke.com">Tobias Rudolphi</a>, Z&uuml;hlke Engineering GmbH, Eschborn, Germany
 *
 * Generated from Unit.xml
 */
var Units = {

    /**
     * @property {Object} LEN The enumeration of all unit codes for flavour LEN
     * @property {String} LEN.BASE Code for si-unit of flavour LEN
     * @property {String} LEN.FEET
     * Code for unit FEET of flavour LEN
     * @property {String} LEN.DM
     * Code for unit DM of flavour LEN
     * @property {String} LEN.KM
     * Code for unit KM of flavour LEN
     * @property {String} LEN.MM
     * Code for unit MM of flavour LEN
     * @property {String} LEN.YARD
     * Code for unit YARD of flavour LEN
     * @property {String} LEN.M
     * Code for unit M of flavour LEN
     * @property {String} LEN.CM
     * Code for unit CM of flavour LEN
     * @property {String} LEN.MILE_NAUTIC
     * Code for unit MILE_NAUTIC of flavour LEN
     * @property {String} LEN.METER
     * Code for unit METER of flavour LEN
     * @property {String} LEN.INCH
     * Code for unit INCH of flavour LEN
     * @property {String} LEN.MILE
     * Code for unit MILE of flavour LEN
     */
    LEN : {
        BASE: 'len_m',
        FEET : 'len_feet',
        DM : 'len_dm',
        KM : 'len_km',
        MM : 'len_mm',
        YARD : 'len_yard',
        M : 'len_m',
        CM : 'len_cm',
        MILE_NAUTIC : 'len_mile_nautic',
        METER : 'len_meter',
        INCH : 'len_inch',
        MILE : 'len_mile'
    },
    /**
     * @property {Object} BUSHEL The enumeration of all unit codes for flavour BUSHEL
     * @property {String} BUSHEL.BASE Code for si-unit of flavour BUSHEL
     * @property {String} BUSHEL.KOERNERMAIS
     * Code for unit KOERNERMAIS of flavour BUSHEL
     * @property {String} BUSHEL.SOMMERGERSTE
     * Code for unit SOMMERGERSTE of flavour BUSHEL
     * @property {String} BUSHEL.SOJABOHNEN
     * Code for unit SOJABOHNEN of flavour BUSHEL
     * @property {String} BUSHEL.MAIS
     * Code for unit MAIS of flavour BUSHEL
     * @property {String} BUSHEL.MITTELFEUCHTERLANGMAIS
     * Code for unit MITTELFEUCHTERLANGMAIS of flavour BUSHEL
     * @property {String} BUSHEL.GERSTE
     * Code for unit GERSTE of flavour BUSHEL
     * @property {String} BUSHEL.BOHNEN
     * Code for unit BOHNEN of flavour BUSHEL
     * @property {String} BUSHEL.MITTELFEUCHTESGRAS
     * Code for unit MITTELFEUCHTESGRAS of flavour BUSHEL
     * @property {String} BUSHEL.TRITIKALE
     * Code for unit TRITIKALE of flavour BUSHEL
     * @property {String} BUSHEL.KNAULGRAS
     * Code for unit KNAULGRAS of flavour BUSHEL
     * @property {String} BUSHEL.ROTSCHWINGEL
     * Code for unit ROTSCHWINGEL of flavour BUSHEL
     * @property {String} BUSHEL.TROCKENERKURZMAIS
     * Code for unit TROCKENERKURZMAIS of flavour BUSHEL
     * @property {String} BUSHEL.KLEE
     * Code for unit KLEE of flavour BUSHEL
     * @property {String} BUSHEL.TROCKENESGRAS
     * Code for unit TROCKENESGRAS of flavour BUSHEL
     * @property {String} BUSHEL.RAPS
     * Code for unit RAPS of flavour BUSHEL
     * @property {String} BUSHEL.TROCKENERLANGMAIS
     * Code for unit TROCKENERLANGMAIS of flavour BUSHEL
     * @property {String} BUSHEL.DEFAULT
     * Code for unit DEFAULT of flavour BUSHEL
     * @property {String} BUSHEL.REIS
     * Code for unit REIS of flavour BUSHEL
     * @property {String} BUSHEL.SONNENBLUMEN
     * Code for unit SONNENBLUMEN of flavour BUSHEL
     * @property {String} BUSHEL.WEIDELGRAS
     * Code for unit WEIDELGRAS of flavour BUSHEL
     * @property {String} BUSHEL.AUSBLASEN
     * Code for unit AUSBLASEN of flavour BUSHEL
     * @property {String} BUSHEL.HAFER
     * Code for unit HAFER of flavour BUSHEL
     * @property {String} BUSHEL.CORNCOBMIX
     * Code for unit CORNCOBMIX of flavour BUSHEL
     * @property {String} BUSHEL.ROGGEN
     * Code for unit ROGGEN of flavour BUSHEL
     * @property {String} BUSHEL.MILO
     * Code for unit MILO of flavour BUSHEL
     * @property {String} BUSHEL.BUCHWEIZEN
     * Code for unit BUCHWEIZEN of flavour BUSHEL
     * @property {String} BUSHEL.FEUCHTERLANGMAIS
     * Code for unit FEUCHTERLANGMAIS of flavour BUSHEL
     * @property {String} BUSHEL.BUSCHBOHNEN
     * Code for unit BUSCHBOHNEN of flavour BUSHEL
     * @property {String} BUSHEL.FEUCHTESGRAS
     * Code for unit FEUCHTESGRAS of flavour BUSHEL
     * @property {String} BUSHEL.LUZERNE
     * Code for unit LUZERNE of flavour BUSHEL
     * @property {String} BUSHEL.KEINEFRUCHT
     * Code for unit KEINEFRUCHT of flavour BUSHEL
     * @property {String} BUSHEL.BRAUGERSTE
     * Code for unit BRAUGERSTE of flavour BUSHEL
     * @property {String} BUSHEL.WEIZEN
     * Code for unit WEIZEN of flavour BUSHEL
     * @property {String} BUSHEL.ACKERBOHNEN
     * Code for unit ACKERBOHNEN of flavour BUSHEL
     * @property {String} BUSHEL.LIESCHKOLBENSCHROT
     * Code for unit LIESCHKOLBENSCHROT of flavour BUSHEL
     * @property {String} BUSHEL.ERBSEN
     * Code for unit ERBSEN of flavour BUSHEL
     * @property {String} BUSHEL.HIRSE
     * Code for unit HIRSE of flavour BUSHEL
     * @property {String} BUSHEL.MITTELFEUCHTERKURZMAIS
     * Code for unit MITTELFEUCHTERKURZMAIS of flavour BUSHEL
     * @property {String} BUSHEL.MOHRENHIRSE
     * Code for unit MOHRENHIRSE of flavour BUSHEL
     * @property {String} BUSHEL.CCM
     * Code for unit CCM of flavour BUSHEL
     * @property {String} BUSHEL.FLACHS
     * Code for unit FLACHS of flavour BUSHEL
     * @property {String} BUSHEL.DINKEL
     * Code for unit DINKEL of flavour BUSHEL
     * @property {String} BUSHEL.GETREIDEPFLANTENSILAGE
     * Code for unit GETREIDEPFLANTENSILAGE of flavour BUSHEL
     * @property {String} BUSHEL.FEUCHTERKURZMAIS
     * Code for unit FEUCHTERKURZMAIS of flavour BUSHEL
     * @property {String} BUSHEL.WINTERGERSTE
     * Code for unit WINTERGERSTE of flavour BUSHEL
     * @property {String} BUSHEL.WIESENRISPE
     * Code for unit WIESENRISPE of flavour BUSHEL
     * @property {String} BUSHEL.LEINSAMEN
     * Code for unit LEINSAMEN of flavour BUSHEL
     */
    BUSHEL : {
        BASE: 'mass_g',
        KOERNERMAIS : 'bushel_Koernermais',
        SOMMERGERSTE : 'bushel_Sommergerste',
        SOJABOHNEN : 'bushel_Sojabohnen',
        MAIS : 'bushel_Mais',
        MITTELFEUCHTERLANGMAIS : 'bushel_MittelfeuchterLangmais',
        GERSTE : 'bushel_Gerste',
        BOHNEN : 'bushel_Bohnen',
        MITTELFEUCHTESGRAS : 'bushel_MittelfeuchtesGras',
        TRITIKALE : 'bushel_Tritikale',
        KNAULGRAS : 'bushel_Knaulgras',
        ROTSCHWINGEL : 'bushel_Rotschwingel',
        TROCKENERKURZMAIS : 'bushel_TrockenerKurzmais',
        KLEE : 'bushel_Klee',
        TROCKENESGRAS : 'bushel_TrockenesGras',
        RAPS : 'bushel_Raps',
        TROCKENERLANGMAIS : 'bushel_TrockenerLangmais',
        DEFAULT : 'bushel_default',
        REIS : 'bushel_Reis',
        SONNENBLUMEN : 'bushel_Sonnenblumen',
        WEIDELGRAS : 'bushel_Weidelgras',
        AUSBLASEN : 'bushel_Ausblasen',
        HAFER : 'bushel_Hafer',
        CORNCOBMIX : 'bushel_CornCobMix',
        ROGGEN : 'bushel_Roggen',
        MILO : 'bushel_Milo',
        BUCHWEIZEN : 'bushel_Buchweizen',
        FEUCHTERLANGMAIS : 'bushel_FeuchterLangmais',
        BUSCHBOHNEN : 'bushel_Buschbohnen',
        FEUCHTESGRAS : 'bushel_FeuchtesGras',
        LUZERNE : 'bushel_Luzerne',
        KEINEFRUCHT : 'bushel_keineFrucht',
        BRAUGERSTE : 'bushel_Braugerste',
        WEIZEN : 'bushel_Weizen',
        ACKERBOHNEN : 'bushel_Ackerbohnen',
        LIESCHKOLBENSCHROT : 'bushel_Lieschkolbenschrot',
        ERBSEN : 'bushel_Erbsen',
        HIRSE : 'bushel_Hirse',
        MITTELFEUCHTERKURZMAIS : 'bushel_MittelfeuchterKurzmais',
        MOHRENHIRSE : 'bushel_Mohrenhirse',
        CCM : 'bushel_CCM',
        FLACHS : 'bushel_Flachs',
        DINKEL : 'bushel_Dinkel',
        GETREIDEPFLANTENSILAGE : 'bushel_Getreidepflantensilage',
        FEUCHTERKURZMAIS : 'bushel_FeuchterKurzmais',
        WINTERGERSTE : 'bushel_Wintergerste',
        WIESENRISPE : 'bushel_Wiesenrispe',
        LEINSAMEN : 'bushel_Leinsamen'
    },
    /**
     * @property {Object} PIECE The enumeration of all unit codes for flavour PIECE
     * @property {String} PIECE.BASE Code for si-unit of flavour PIECE
     * @property {String} PIECE.GRAIN
     * Code for unit GRAIN of flavour PIECE
     * @property {String} PIECE.TGRAIN
     * Code for unit TGRAIN of flavour PIECE
     */
    PIECE : {
        BASE: 'piece_grain',
        GRAIN : 'piece_grain',
        TGRAIN : 'piece_tgrain'
    },
    /**
     * @property {Object} PRESSURE The enumeration of all unit codes for flavour PRESSURE
     * @property {String} PRESSURE.BASE Code for si-unit of flavour PRESSURE
     * @property {String} PRESSURE.BAR
     * Code for unit BAR of flavour PRESSURE
     * @property {String} PRESSURE.KPA
     * Code for unit KPA of flavour PRESSURE
     * @property {String} PRESSURE.MBAR
     * Code for unit MBAR of flavour PRESSURE
     */
    PRESSURE : {
        BASE: 'pressure_bar',
        BAR : 'pressure_bar',
        KPA : 'pressure_kpa',
        MBAR : 'pressure_mbar'
    },
    /**
     * @property {Object} LIQUIDPERLEN The enumeration of all unit codes for flavour LIQUIDPERLEN
     * @property {String} LIQUIDPERLEN.BASE Code for si-unit of flavour LIQUIDPERLEN
     * @property {String} LIQUIDPERLEN.GALLONPERMILE
     * Code for unit GALLONPERMILE of flavour LIQUIDPERLEN
     * @property {String} LIQUIDPERLEN.LPERDM
     * Code for unit LPERDM of flavour LIQUIDPERLEN
     * @property {String} LIQUIDPERLEN.LPERKM
     * Code for unit LPERKM of flavour LIQUIDPERLEN
     */
    LIQUIDPERLEN : {
        BASE: 'liquidPERlen_lperkm',
        GALLONPERMILE : 'liquidPERlen_gallonpermile',
        LPERDM : 'liquidPERlen_lperdm',
        LPERKM : 'liquidPERlen_lperkm'
    },
    /**
     * @property {Object} WARTUNGSMELDUNG The enumeration of all unit codes for flavour WARTUNGSMELDUNG
     * @property {String} WARTUNGSMELDUNG.BASE Code for si-unit of flavour WARTUNGSMELDUNG
     * @property {String} WARTUNGSMELDUNG.WERT
     * Code for unit WERT of flavour WARTUNGSMELDUNG
     * @property {String} WARTUNGSMELDUNG.ROH
     * Code for unit ROH of flavour WARTUNGSMELDUNG
     */
    WARTUNGSMELDUNG : {
        BASE: 'wartungsmeldung_roh',
        WERT : 'wartungsmeldung_wert',
        ROH : 'wartungsmeldung_roh'
    },
    /**
     * @property {Object} LIQUIDPERAREAL The enumeration of all unit codes for flavour LIQUIDPERAREAL
     * @property {String} LIQUIDPERAREAL.BASE Code for si-unit of flavour LIQUIDPERAREAL
     * @property {String} LIQUIDPERAREAL.GALLONPERACRE
     * Code for unit GALLONPERACRE of flavour LIQUIDPERAREAL
     * @property {String} LIQUIDPERAREAL.CMMPERQM
     * Code for unit CMMPERQM of flavour LIQUIDPERAREAL
     * @property {String} LIQUIDPERAREAL.LPERQM
     * Code for unit LPERQM of flavour LIQUIDPERAREAL
     * @property {String} LIQUIDPERAREAL.LPERHA
     * Code for unit LPERHA of flavour LIQUIDPERAREAL
     */
    LIQUIDPERAREAL : {
        BASE: 'liquidPERareal_lperha',
        GALLONPERACRE : 'liquidPERareal_gallonperacre',
        CMMPERQM : 'liquidPERareal_cmmperqm',
        LPERQM : 'liquidPERareal_lperqm',
        LPERHA : 'liquidPERareal_lperha'
    },
    /**
     * @property {Object} ACCELERATION The enumeration of all unit codes for flavour ACCELERATION
     * @property {String} ACCELERATION.BASE Code for si-unit of flavour ACCELERATION
     * @property {String} ACCELERATION.MPERQS
     * Code for unit MPERQS of flavour ACCELERATION
     * @property {String} ACCELERATION.GRAINPERQM
     * Code for unit GRAINPERQM of flavour ACCELERATION
     */
    ACCELERATION : {
        BASE: 'acceleration_mperqs',
        MPERQS : 'acceleration_mperqs',
        GRAINPERQM : 'acceleration_grainperqm'
    },
    /**
     * @property {Object} PIECEPERAREAL The enumeration of all unit codes for flavour PIECEPERAREAL
     * @property {String} PIECEPERAREAL.BASE Code for si-unit of flavour PIECEPERAREAL
     * @property {String} PIECEPERAREAL.TGRAINPERHA
     * Code for unit TGRAINPERHA of flavour PIECEPERAREAL
     * @property {String} PIECEPERAREAL.GRAINPERQM
     * Code for unit GRAINPERQM of flavour PIECEPERAREAL
     * @property {String} PIECEPERAREAL.GRAINPERHA
     * Code for unit GRAINPERHA of flavour PIECEPERAREAL
     */
    PIECEPERAREAL : {
        BASE: 'piecePERareal_grainperha',
        TGRAINPERHA : 'piecePERareal_tgrainperha',
        GRAINPERQM : 'piecePERareal_grainperqm',
        GRAINPERHA : 'piecePERareal_grainperha'
    },
    /**
     * @property {Object} TIME The enumeration of all unit codes for flavour TIME
     * @property {String} TIME.BASE Code for si-unit of flavour TIME
     * @property {String} TIME.H
     * Code for unit H of flavour TIME
     * @property {String} TIME.MS
     * Code for unit MS of flavour TIME
     * @property {String} TIME.MIN
     * Code for unit MIN of flavour TIME
     * @property {String} TIME.S
     * Code for unit S of flavour TIME
     */
    TIME : {
        BASE: 'time_s',
        H : 'time_h',
        MS : 'time_ms',
        MIN : 'time_min',
        S : 'time_s'
    },
    /**
     * @property {Object} POSITION The enumeration of all unit codes for flavour POSITION
     * @property {String} POSITION.BASE Code for si-unit of flavour POSITION
     * @property {String} POSITION.TGRAD
     * Code for unit TGRAD of flavour POSITION
     * @property {String} POSITION.GRAD
     * Code for unit GRAD of flavour POSITION
     */
    POSITION : {
        BASE: 'position_grad',
        TGRAD : 'position_tgrad',
        GRAD : 'position_grad'
    },
    /**
     * @property {Object} MASSPERAREAL The enumeration of all unit codes for flavour MASSPERAREAL
     * @property {String} MASSPERAREAL.BASE Code for si-unit of flavour MASSPERAREAL
     * @property {String} MASSPERAREAL.BUSHELPERACRE
     * Code for unit BUSHELPERACRE of flavour MASSPERAREAL
     * @property {String} MASSPERAREAL.TPERHA
     * Code for unit TPERHA of flavour MASSPERAREAL
     * @property {String} MASSPERAREAL.KGPERQM
     * Code for unit KGPERQM of flavour MASSPERAREAL
     * @property {String} MASSPERAREAL.LONGTONPERACRE
     * Code for unit LONGTONPERACRE of flavour MASSPERAREAL
     * @property {String} MASSPERAREAL.KGPERHA
     * Code for unit KGPERHA of flavour MASSPERAREAL
     * @property {String} MASSPERAREAL.MGPERQM
     * Code for unit MGPERQM of flavour MASSPERAREAL
     * @property {String} MASSPERAREAL.TPERACRE
     * Code for unit TPERACRE of flavour MASSPERAREAL
     */
    MASSPERAREAL : {
        BASE: 'massPERareal_kgperha',
        BUSHELPERACRE : 'massPERareal_bushelperacre',
        TPERHA : 'massPERareal_tperha',
        KGPERQM : 'massPERareal_kgperqm',
        LONGTONPERACRE : 'massPERareal_longtonperacre',
        KGPERHA : 'massPERareal_kgperha',
        MGPERQM : 'massPERareal_mgperqm',
        TPERACRE : 'massPERareal_tperacre'
    },
    /**
     * @property {Object} LIQUIDPERTIME The enumeration of all unit codes for flavour LIQUIDPERTIME
     * @property {String} LIQUIDPERTIME.BASE Code for si-unit of flavour LIQUIDPERTIME
     * @property {String} LIQUIDPERTIME.LPERH
     * Code for unit LPERH of flavour LIQUIDPERTIME
     * @property {String} LIQUIDPERTIME.GALLONPERH
     * Code for unit GALLONPERH of flavour LIQUIDPERTIME
     * @property {String} LIQUIDPERTIME.LPERMIN
     * Code for unit LPERMIN of flavour LIQUIDPERTIME
     * @property {String} LIQUIDPERTIME.CMMPERS
     * Code for unit CMMPERS of flavour LIQUIDPERTIME
     */
    LIQUIDPERTIME : {
        BASE: 'liquidPERtime_lperh',
        LPERH : 'liquidPERtime_lperh',
        GALLONPERH : 'liquidPERtime_gallonperh',
        LPERMIN : 'liquidPERtime_lpermin',
        CMMPERS : 'liquidPERtime_cmmpers'
    },
    /**
     * @property {Object} CURRENCY The enumeration of all unit codes for flavour CURRENCY
     * @property {String} CURRENCY.BASE Code for si-unit of flavour CURRENCY
     * @property {String} CURRENCY.PESO
     * Code for unit PESO of flavour CURRENCY
     * @property {String} CURRENCY.POUND
     * Code for unit POUND of flavour CURRENCY
     * @property {String} CURRENCY.DEFAULT
     * Code for unit DEFAULT of flavour CURRENCY
     * @property {String} CURRENCY.DOLLAR
     * Code for unit DOLLAR of flavour CURRENCY
     * @property {String} CURRENCY.EURO
     * Code for unit EURO of flavour CURRENCY
     */
    CURRENCY : {
        BASE: 'currency_default',
        PESO : 'currency_peso',
        POUND : 'currency_pound',
        DEFAULT : 'currency_default',
        DOLLAR : 'currency_dollar',
        EURO : 'currency_euro'
    },
    /**
     * @property {Object} BOOLEAN The enumeration of all unit codes for flavour BOOLEAN
     * @property {String} BOOLEAN.BASE Code for si-unit of flavour BOOLEAN
     * @property {String} BOOLEAN.IO
     * Code for unit IO of flavour BOOLEAN
     */
    BOOLEAN : {
        BASE: 'boolean_io',
        IO : 'boolean_io'
    },
    /**
     * @property {Object} MASSPERTIME The enumeration of all unit codes for flavour MASSPERTIME
     * @property {String} MASSPERTIME.BASE Code for si-unit of flavour MASSPERTIME
     * @property {String} MASSPERTIME.KGPERS
     * Code for unit KGPERS of flavour MASSPERTIME
     * @property {String} MASSPERTIME.BUSHELPERH
     * Code for unit BUSHELPERH of flavour MASSPERTIME
     * @property {String} MASSPERTIME.LONGTONPERH
     * Code for unit LONGTONPERH of flavour MASSPERTIME
     * @property {String} MASSPERTIME.KGPERMIN
     * Code for unit KGPERMIN of flavour MASSPERTIME
     * @property {String} MASSPERTIME.TPERH
     * Code for unit TPERH of flavour MASSPERTIME
     * @property {String} MASSPERTIME.MGPERS
     * Code for unit MGPERS of flavour MASSPERTIME
     * @property {String} MASSPERTIME.KGPERH
     * Code for unit KGPERH of flavour MASSPERTIME
     */
    MASSPERTIME : {
        BASE: 'massPERtime_kgperh',
        KGPERS : 'massPERtime_kgpers',
        BUSHELPERH : 'massPERtime_bushelperh',
        LONGTONPERH : 'massPERtime_longtonperh',
        KGPERMIN : 'massPERtime_kgpermin',
        TPERH : 'massPERtime_tperh',
        MGPERS : 'massPERtime_mgpers',
        KGPERH : 'massPERtime_kgperh'
    },
    /**
     * @property {Object} LIQUID The enumeration of all unit codes for flavour LIQUID
     * @property {String} LIQUID.BASE Code for si-unit of flavour LIQUID
     * @property {String} LIQUID.BUSHEL
     * Code for unit BUSHEL of flavour LIQUID
     * @property {String} LIQUID.DRAM_GB
     * Code for unit DRAM_GB of flavour LIQUID
     * @property {String} LIQUID.PINT_GB
     * Code for unit PINT_GB of flavour LIQUID
     * @property {String} LIQUID.GALLON
     * Code for unit GALLON of flavour LIQUID
     * @property {String} LIQUID.QUART
     * Code for unit QUART of flavour LIQUID
     * @property {String} LIQUID.ML
     * Code for unit ML of flavour LIQUID
     * @property {String} LIQUID.QUART_GB
     * Code for unit QUART_GB of flavour LIQUID
     * @property {String} LIQUID.BARREL_GB
     * Code for unit BARREL_GB of flavour LIQUID
     * @property {String} LIQUID.L
     * Code for unit L of flavour LIQUID
     * @property {String} LIQUID.BARREL
     * Code for unit BARREL of flavour LIQUID
     * @property {String} LIQUID.BUSHEL_GB
     * Code for unit BUSHEL_GB of flavour LIQUID
     * @property {String} LIQUID.MINIM
     * Code for unit MINIM of flavour LIQUID
     * @property {String} LIQUID.GALLON_GB
     * Code for unit GALLON_GB of flavour LIQUID
     * @property {String} LIQUID.MINIM_GB
     * Code for unit MINIM_GB of flavour LIQUID
     * @property {String} LIQUID.PINT
     * Code for unit PINT of flavour LIQUID
     * @property {String} LIQUID.DRAM
     * Code for unit DRAM of flavour LIQUID
     */
    LIQUID : {
        BASE: 'liquid_ml',
        BUSHEL : 'liquid_bushel',
        DRAM_GB : 'liquid_dram_gb',
        PINT_GB : 'liquid_pint_gb',
        GALLON : 'liquid_gallon',
        QUART : 'liquid_quart',
        ML : 'liquid_ml',
        QUART_GB : 'liquid_quart_gb',
        BARREL_GB : 'liquid_barrel_gb',
        L : 'liquid_l',
        BARREL : 'liquid_barrel',
        BUSHEL_GB : 'liquid_bushel_gb',
        MINIM : 'liquid_minim',
        GALLON_GB : 'liquid_gallon_gb',
        MINIM_GB : 'liquid_minim_gb',
        PINT : 'liquid_pint',
        DRAM : 'liquid_dram'
    },
    /**
     * @property {Object} MASS The enumeration of all unit codes for flavour MASS
     * @property {String} MASS.BASE Code for si-unit of flavour MASS
     * @property {String} MASS.BUSHEL
     * Code for unit BUSHEL of flavour MASS
     * @property {String} MASS.GRAIN
     * Code for unit GRAIN of flavour MASS
     * @property {String} MASS.TON
     * Code for unit TON of flavour MASS
     * @property {String} MASS.KG
     * Code for unit KG of flavour MASS
     * @property {String} MASS.OUNCE
     * Code for unit OUNCE of flavour MASS
     * @property {String} MASS.LONGTON
     * Code for unit LONGTON of flavour MASS
     * @property {String} MASS.G
     * Code for unit G of flavour MASS
     * @property {String} MASS.POUND
     * Code for unit POUND of flavour MASS
     * @property {String} MASS.SLUG
     * Code for unit SLUG of flavour MASS
     * @property {String} MASS.DRAM
     * Code for unit DRAM of flavour MASS
     */
    MASS : {
        BASE: 'mass_g',
        BUSHEL : 'mass_bushel',
        GRAIN : 'mass_grain',
        TON : 'mass_ton',
        KG : 'mass_kg',
        OUNCE : 'mass_ounce',
        LONGTON : 'mass_longton',
        G : 'mass_g',
        POUND : 'mass_pound',
        SLUG : 'mass_slug',
        DRAM : 'mass_dram',
        DT : 'mass_dt',
    },
    /**
     * @property {Object} SPEED The enumeration of all unit codes for flavour SPEED
     * @property {String} SPEED.BASE Code for si-unit of flavour SPEED
     * @property {String} SPEED.INS
     * Code for unit INS of flavour SPEED
     * @property {String} SPEED.MH
     * Code for unit MH of flavour SPEED
     * @property {String} SPEED.MPH
     * Code for unit MPH of flavour SPEED
     * @property {String} SPEED.MS
     * Code for unit MS of flavour SPEED
     * @property {String} SPEED.KN
     * Code for unit KN of flavour SPEED
     * @property {String} SPEED.FTS
     * Code for unit FTS of flavour SPEED
     * @property {String} SPEED.CMMIN
     * Code for unit CMMIN of flavour SPEED
     * @property {String} SPEED.KMH
     * Code for unit KMH of flavour SPEED
     */
    SPEED : {
        BASE: 'speed_ms',
        INS : 'speed_ins',
        MH : 'speed_mh',
        MPH : 'speed_mph',
        MS : 'speed_ms',
        KN : 'speed_kn',
        FTS : 'speed_fts',
        CMMIN : 'speed_cmmin',
        KMH : 'speed_kmh'
    },
    /**
     * @property {Object} AREALPERTIME The enumeration of all unit codes for flavour AREALPERTIME
     * @property {String} AREALPERTIME.BASE Code for si-unit of flavour AREALPERTIME
     * @property {String} AREALPERTIME.HAPERH
     * Code for unit HAPERH of flavour AREALPERTIME
     * @property {String} AREALPERTIME.QMPERMIN
     * Code for unit QMPERMIN of flavour AREALPERTIME
     * @property {String} AREALPERTIME.QMMPERS
     * Code for unit QMMPERS of flavour AREALPERTIME
     * @property {String} AREALPERTIME.ACREPERH
     * Code for unit ACREPERH of flavour AREALPERTIME
     * @property {String} AREALPERTIME.QMPERH
     * Code for unit QMPERH of flavour AREALPERTIME
     * @property {String} AREALPERTIME.QMPERS
     * Code for unit QMPERS of flavour AREALPERTIME
     */
    AREALPERTIME : {
        BASE: 'arealPERtime_qmperh',
        HAPERH : 'arealPERtime_haperh',
        QMPERMIN : 'arealPERtime_qmpermin',
        QMMPERS : 'arealPERtime_qmmpers',
        ACREPERH : 'arealPERtime_acreperh',
        QMPERH : 'arealPERtime_qmperh',
        QMPERS : 'arealPERtime_qmpers'
    },
    /**
     * @property {Object} LIQUIDPERMASS The enumeration of all unit codes for flavour LIQUIDPERMASS
     * @property {String} LIQUIDPERMASS.BASE Code for si-unit of flavour LIQUIDPERMASS
     * @property {String} LIQUIDPERMASS.LPERKG
     * Code for unit LPERKG of flavour LIQUIDPERMASS
     * @property {String} LIQUIDPERMASS.LPERT
     * Code for unit LPERT of flavour LIQUIDPERMASS
     * @property {String} LIQUIDPERMASS.GALLONPERKG
     * Code for unit GALLONPERKG of flavour LIQUIDPERMASS
     * @property {String} LIQUIDPERMASS.GALLONPERT
     * Code for unit GALLONPERT of flavour LIQUIDPERMASS
     */
    LIQUIDPERMASS : {
        BASE: 'liquidPERmass_lpert',
        LPERKG : 'liquidPERmass_lperkg',
        LPERT : 'liquidPERmass_lpert',
        GALLONPERKG : 'liquidPERmass_gallonperkg',
        GALLONPERT : 'liquidPERmass_gallonpert'
    },
    /**
     * @property {Object} CONCENTRATION The enumeration of all unit codes for flavour CONCENTRATION
     * @property {String} CONCENTRATION.BASE Code for si-unit of flavour CONCENTRATION
     * @property {String} CONCENTRATION.MGPL
     * Code for unit MGPL of flavour CONCENTRATION
     * @property {String} CONCENTRATION.GPML
     * Code for unit GPML of flavour CONCENTRATION
     * @property {String} CONCENTRATION.GPL
     * Code for unit GPL of flavour CONCENTRATION
     */
    CONCENTRATION : {
        BASE: 'concentration_gpml',
        MGPL : 'concentration_mgpl',
        GPML : 'concentration_gpml',
        GPL : 'concentration_gpl'
    },
    /**
     * @property {Object} DATATYP The enumeration of all unit codes for flavour DATATYP
     * @property {String} DATATYP.BASE Code for si-unit of flavour DATATYP
     * @property {String} DATATYP.BYTE
     * Code for unit BYTE of flavour DATATYP
     */
    DATATYP : {
        BASE: 'datatyp_byte',
        BYTE : 'datatyp_byte'
    },
    /**
     * @property {Object} ELECTRICITY The enumeration of all unit codes for flavour ELECTRICITY
     * @property {String} ELECTRICITY.BASE Code for si-unit of flavour ELECTRICITY
     * @property {String} ELECTRICITY.MA
     * Code for unit MA of flavour ELECTRICITY
     * @property {String} ELECTRICITY.A
     * Code for unit A of flavour ELECTRICITY
     */
    ELECTRICITY : {
        BASE: 'electricity_a',
        MA : 'electricity_ma',
        A : 'electricity_a'
    },
    /**
     * @property {Object} DEFAULT The enumeration of all unit codes for flavour DEFAULT
     * @property {String} DEFAULT.BASE Code for si-unit of flavour DEFAULT
     * @property {String} DEFAULT.FALCOMDIESELPC
     * Code for unit FALCOMDIESELPC of flavour DEFAULT
     * @property {String} DEFAULT.DIGIT
     * Code for unit DIGIT of flavour DEFAULT
     * @property {String} DEFAULT.DIGITFACTOR100
     * Code for unit DIGITFACTOR100 of flavour DEFAULT
     * @property {String} DEFAULT.FALCOMDIESEL
     * Code for unit FALCOMDIESEL of flavour DEFAULT
     */
    DEFAULT : {
        BASE: 'default_digit',
        FALCOMDIESELPC : 'default_falcomdieselpc',
        DIGIT : 'default_digit',
        DIGITFACTOR100 : 'default_digitFactor100',
        FALCOMDIESEL : 'default_falcomdiesel'
    },
    /**
     * @property {Object} PERCENTAGE The enumeration of all unit codes for flavour PERCENTAGE
     * @property {String} PERCENTAGE.BASE Code for si-unit of flavour PERCENTAGE
     * @property {String} PERCENTAGE.PMIL
     * Code for unit PMIL of flavour PERCENTAGE
     * @property {String} PERCENTAGE.PPM
     * Code for unit PPM of flavour PERCENTAGE
     * @property {String} PERCENTAGE.PDMIL
     * Code for unit PDMIL of flavour PERCENTAGE
     * @property {String} PERCENTAGE.PC
     * Code for unit PC of flavour PERCENTAGE
     * @property {String} PERCENTAGE.PCMIL
     * Code for unit PCMIL of flavour PERCENTAGE
     */
    PERCENTAGE : {
        BASE: 'percentage_pdmil',
        PMIL : 'percentage_pmil',
        PPM : 'percentage_ppm',
        PDMIL : 'percentage_pdmil',
        PC : 'percentage_pc',
        PCMIL : 'percentage_pcmil'
    },
    /**
     * @property {Object} VOLTAGE The enumeration of all unit codes for flavour VOLTAGE
     * @property {String} VOLTAGE.BASE Code for si-unit of flavour VOLTAGE
     * @property {String} VOLTAGE.V
     * Code for unit V of flavour VOLTAGE
     */
    VOLTAGE : {
        BASE: 'voltage_v',
        V : 'voltage_v'
    },
    /**
     * @property {Object} TEMP The enumeration of all unit codes for flavour TEMP
     * @property {String} TEMP.BASE Code for si-unit of flavour TEMP
     * @property {String} TEMP.DEGREEFAHRENHEIT
     * Code for unit DEGREEFAHRENHEIT of flavour TEMP
     * @property {String} TEMP.DEGREECELSIUS
     * Code for unit DEGREECELSIUS of flavour TEMP
     */
    TEMP : {
        BASE: 'temp_degreecelsius',
        DEGREEFAHRENHEIT : 'temp_degreefahrenheit',
        DEGREECELSIUS : 'temp_degreecelsius'
    },
    /**
     * @property {Object} AREAL The enumeration of all unit codes for flavour AREAL
     * @property {String} AREAL.BASE Code for si-unit of flavour AREAL
     * @property {String} AREAL.SQROD
     * Code for unit SQROD of flavour AREAL
     * @property {String} AREAL.QM
     * Code for unit QM of flavour AREAL
     * @property {String} AREAL.SQFEET
     * Code for unit SQFEET of flavour AREAL
     * @property {String} AREAL.SQYARD
     * Code for unit SQYARD of flavour AREAL
     * @property {String} AREAL.HA
     * Code for unit HA of flavour AREAL
     * @property {String} AREAL.ACRE
     * Code for unit ACRE of flavour AREAL
     * @property {String} AREAL.AR
     * Code for unit AR of flavour AREAL
     */
    AREAL : {
        BASE: 'areal_qm',
        SQROD : 'areal_sqrod',
        QM : 'areal_qm',
        SQFEET : 'areal_sqfeet',
        SQYARD : 'areal_sqyard',
        HA : 'areal_ha',
        ACRE : 'areal_acre',
        AR : 'areal_ar'
    },
    /**
     * @property {Object} ROUNDS The enumeration of all unit codes for flavour ROUNDS
     * @property {String} ROUNDS.BASE Code for si-unit of flavour ROUNDS
     * @property {String} ROUNDS.UMIN
     * Code for unit UMIN of flavour ROUNDS
     * @property {String} ROUNDS.RPM
     * Code for unit RPM of flavour ROUNDS
     * @property {String} ROUNDS.OBRMIN
     * Code for unit OBRMIN of flavour ROUNDS
     */
    ROUNDS : {
        BASE: 'rounds_umin',
        UMIN : 'rounds_umin',
        RPM : 'rounds_rpm',
        OBRMIN : 'rounds_obrmin'
    },
    VOLUME : {
        BASE: 'liquid_ml',
        M3 : 'volume_m3'
    }
};

angular
    .module('cfn')
    .run(['$rootScope', function($rootScope){
        $rootScope.Units = Units;
    }]);

global.Units = Units;
